import { usePersistFn } from 'ahooks'

export function useScrollTo(ref: React.RefObject<HTMLElement>) {
    const scrollToBottom = usePersistFn(() => {
        if (ref.current) ref.current.scrollTop = ref.current.scrollHeight
    })

    const scrollToTop = usePersistFn(() => {
        if (ref.current) ref.current.scrollTop = 0
    })

    const scrollTo = usePersistFn((value: number) => {
        if (ref.current) ref.current.scrollTop = value
    })

    return {
        scrollToBottom,
        scrollToTop,
        scrollTo,
    }
}
